import { createElement, useEffect, useState } from "react";
import * as Scrivito from "scrivito";
import { isBrowser } from "^/utils/isBrowser";
import "./tab-widget.scss";

Scrivito.provideComponent(
  "TabWidget",
  Scrivito.connect(({ widget }) => {
    const style = widget.get("style") || "default-style";
    const tabs = widget.get("tabs") || [];
    const asHeadline = widget.get("asHeadline");

    const [isMobile, setIsMobile] = useState(
      isBrowser && window.innerWidth <= 912
    );
    const [activeTab, setActiveTab] = useState(isMobile ? null : 0);

    const handleMobileClick = (event, index) => {
      const offset = 150;

      setActiveTab(index);
      setTimeout(() => {
        const elementTop = event.target.getBoundingClientRect().top;
        window.scrollBy({ top: elementTop - offset, behavior: "smooth" });
      }, 300);
    };

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 912);
      };
      window.addEventListener("resize", handleResize);
      handleResize();
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    if (!tabs.length) return null;

    if (isMobile) {
      return (
        <div className={`tab-widget --mobile --${style}`}>
          {tabs.map((tab, index) => (
            <div
              className={`tab-widget-item ${
                index === activeTab ? "--active" : "--inactive"
              }`}
              key={index}
            >
              <div
                className="tab-widget-header"
                onClick={(e) =>
                  handleMobileClick(e, activeTab === index ? null : index)
                }
              >
                {asHeadline ? (
                  createElement(
                    asHeadline,
                    { className: "tab-widget-header__headline" },
                    tab.get("headline")
                  )
                ) : (
                  <span>{tab.get("headline")}</span>
                )}
                <i className="las la-angle-down" />
              </div>
              <div className="tab-widget-body">
                <Scrivito.ContentTag content={tab} attribute="content" />
              </div>
            </div>
          ))}
        </div>
      );
    }

    return (
      <div className={`tab-widget --${style}`}>
        <ul className="tab-widget-header">
          {tabs.map((tab, index) => (
            <li
              key={tab.id()}
              className={activeTab === index ? "--active" : "--inactive"}
              onClick={() => setActiveTab(index)}
            >
              {asHeadline ? (
                createElement(
                  asHeadline,
                  { className: "tab-widget-header__headline" },
                  tab.get("headline")
                )
              ) : (
                <span>{tab.get("headline")}</span>
              )}
            </li>
          ))}
        </ul>

        <div className="tab-widget-body">
          {tabs.map((tab, index) => (
            <div
              key={tab.id()}
              style={index === activeTab ? undefined : { display: "none" }}
            >
              <Scrivito.ContentTag content={tab} attribute="content" />
            </div>
          ))}
        </div>
      </div>
    );
  })
);
